import cl from 'classnames';
import * as React from 'react';
import { ReactEditor, useSlate } from 'slate-react';
import styled from 'styled-components';

import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';
import { defaultIsEmptyText, EditorPlaceHolder } from './EditorPlaceHolder';

const Main = styled.div``;

interface OutlineParagraphIdeaTitleProps extends BaseOutlineParagraphProps {}

export const OutlineParagraphIdeaTitle = (props: OutlineParagraphIdeaTitleProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const editor = useSlate();
  const rowIndex = ReactEditor.findPath(editor as any, element)
    .slice(0, -1)
    .pop();

  return (
    <EditorPlaceHolder
      isEmptyText={() => {
        return defaultIsEmptyText(element);
      }}
      placeHolderText={`Idea ${rowIndex + 1}`}
      isReadOnly={isReadOnly}
    >
      <Main {...attributes} className={cl('outline-paragraph-idea-title-element', element.id)}>
        {children}
      </Main>
    </EditorPlaceHolder>
  );
};
